/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc
 */
import * as References from './AccessRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc#loginVerify
 */
export const LOGIN_VERIFY_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AccessRpc_loginVerify';
export const LOGIN_VERIFY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LOGIN_VERIFY_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.loginVerifyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});